import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box
} from '@mui/material';

import ScienceIcon from '@mui/icons-material/Science';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';

export default function LabVitalsSection({
  onLabsUpload,
  onVitalsUpload
}) {
  const handleFileUpload = (callback) => (e) => {
    const file = e.target.files[0];
    if (file?.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => callback(e.target.result);
      reader.readAsText(file);
    }
  };

  const downloadTemplate = (filename, content) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader title="Labs and Vitals" sx={{ backgroundColor: '#f5f5f5' }} />
      <CardContent>
        <Grid container spacing={4}>

          {/* Lab Results */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <ScienceIcon sx={{ mr: 1 }} /> Lab Results
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onLabsUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'labs_template.txt',
                    'HbA1c: 6.7%\nCreatinine: 1.1\nTotal Cholesterol: 190\nHDL: 45\nLDL: 110'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

          {/* Vital Signs */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <MonitorHeartIcon sx={{ mr: 1 }} /> Vital Signs
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onVitalsUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'vitals_template.txt',
                    'BP: 130/85\nHR: 78\nSPO2: 97%\nTemp: 98.2°F\nWeight: 189 lbs'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
}
